import PropTypes from 'prop-types';
import React, { createContext, useContext, useState } from 'react';

const DEFAULT_CONFIG = {
  getPopoverContainer: () => document.querySelector('body'),
};

export const SparkConfigProviderContext = createContext(DEFAULT_CONFIG);

/**
 * SparkConfigProvider allows apps to override default configurations, namely:
 * spinner looks and the popover default container
 */
export default function SparkConfigProvider({ sparkConfig, children }) {
  const [context] = useState({ ...DEFAULT_CONFIG, ...sparkConfig });
  return (
    <SparkConfigProviderContext.Provider value={context}>
      {children}
    </SparkConfigProviderContext.Provider>
  );
}

export function useSparkConfig() {
  return useContext(SparkConfigProviderContext);
}

SparkConfigProvider.propTypes = {
  sparkConfig: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
};

SparkConfigProvider.defaultProps = {
  sparkConfig: {},
};

SparkConfigProvider.displayName = 'SparkConfigProvider';
